<template>
	<div>
		<el-dialog :title="editForm.id==null||editForm==''?'登记充电站':'编辑充电站'" width="900px" :visible="addFormVisible"
			:close-on-click-modal="false" :close-on-press-escape="editForm.id!=null&&editForm!=''"
			:modal-append-to-body='false' :before-close="clearEditForm">
			<!--外部对话框 form-->
			<el-form :model="editForm" ref="editForm" :rules="editFormRules" size="mini" class="edit_form">
				<el-col :span="12">
					<el-form-item label="充电站名称：" :label-width="formLabelWidth" prop="stationName">
						<el-input v-model="editForm.stationName" autocomplete="off"></el-input>
					</el-form-item>
				</el-col>

        <el-col :span="12">
          <el-form-item label="运营商：" :label-width="formLabelWidth" prop="operatorId">
            <!--          <el-select placeholder="运营商" v-model="editForm.operatorId">
            <el-option v-for="item in operatorForSelect" :key="item.id" :disabled="operatorDisable(item)"
                       v-bind:label="item.name" v-bind:value="item.id"></el-option>
          </el-select>-->
            <el-cascader size="mini" ref="cascader" placeholder="运营商" filterable
                         :disabled="true"
                         :options="this.setTreeDisable(this.operatorForSelect)"
                         :props="{ checkStrictly:true,expandTrigger:'hover'}" :show-all-levels="false"
                         change-on-select @change='handleChangeOperator' v-model="editForm.operatorId">
            </el-cascader>
          </el-form-item>
        </el-col>

        <el-col :span="12" v-if="!editForm.id">
          <el-form-item label="费率：" :label-width="formLabelWidth" prop="serviceBillingRulesIdTemp">
            <el-select placeholder="请选择费率" filterable v-model="editForm.serviceBillingRulesIdTemp">
              <el-option
                v-for="item in serviceBillingRulesSelect"
                :key="item.id"
                v-bind:label="item.ruleName"
                v-bind:value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>

				<el-col :span="12">
					<el-form-item label="充电站类型：" :label-width="formLabelWidth" prop="stationType">
						<el-select placeholder="充电站类型" v-model="editForm.stationType">
							<el-option v-for="item in stationTypeData" :key="item.value" v-bind:label="item.message"
								v-bind:value="item.value"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="充电站状态：" :label-width="formLabelWidth" prop="stationStatus">
						<el-select placeholder="请选择充电站状态" v-model="editForm.stationStatus">
							<el-option v-for="item in stationStatusData" :key="item.value" v-bind:label="item.message"
								v-bind:value="item.value"></el-option>
						</el-select>
					</el-form-item>
				</el-col>

				<el-col :span="12">
					<el-form-item label="所在省：" :label-width="formLabelWidth" prop="province">
						<el-input placeholder="上传站点地址后填充" disabled v-model="editForm.province" autocomplete="off">
						</el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="所在市：" :label-width="formLabelWidth" prop="city">
						<el-input placeholder="上传站点地址后填充" disabled v-model="editForm.city" autocomplete="off">
						</el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="所在县/区：" :label-width="formLabelWidth" prop="area">
						<el-input placeholder="上传站点地址后填充" disabled v-model="editForm.area" autocomplete="off">
						</el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="详细地址：" :label-width="formLabelWidth" prop="address">
						<el-input autocomplete="off" placeholder="从右边按钮上传站点地址" id="address" v-model="editForm.address">
						</el-input>
						<el-button @click="showInnerForm">上传
							<i class="el-icon-upload el-icon--right"></i>
						</el-button>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="经度：" :label-width="formLabelWidth" prop="longitude">
						<el-input placeholder="上传站点地址后填充" disabled autocomplete="off" v-model="editForm.longitude">
						</el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="纬度：" :label-width="formLabelWidth" prop="latitude">
						<el-input placeholder="上传站点地址后填充" disabled autocomplete="off" v-model="editForm.latitude">
						</el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="地区编码：" :label-width="formLabelWidth" prop="areaCode">
						<el-input placeholder="上传站点地址后填充" v-model="editForm.areaCode" disabled  autocomplete="off"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="场站面积/平米" :label-width="formLabelWidth" prop="siteArea">
						<el-input autocomplete="off" v-model="editForm.siteArea"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="地区类型：" :label-width="formLabelWidth" prop="addressType">
						<el-select placeholder="地区类型" v-model="editForm.addressType">
							<el-option v-for="item in addressTypeData" :key="item.value" v-bind:label="item.message"
								v-bind:value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="负责人：" :label-width="formLabelWidth" prop="dutyPerson">
						<el-input autocomplete="off" v-model="editForm.dutyPerson"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="服务电话：" :label-width="formLabelWidth" prop="dutyPersonPhone">
						<el-input autocomplete="off" v-model="editForm.dutyPersonPhone"></el-input>
					</el-form-item>
				</el-col>

				<el-col :span="12">
					<el-form-item label="营业时间：" :label-width="formLabelWidth">
						<el-col v-for="(item,i) in business" :key="i">
							<el-time-select class="limitedTimePicker" placeholder="开始" v-model="item[0]"
								:picker-options="{
					  start: '00:00',
					  step: '00:10',
					  end: '24:00',
					  minTime:  i > 0 && business[i-1][1] ? business[i-1][1].split(':')[0]+':'+(business[i-1][1].split(':')[1]-1) : '',
					}"></el-time-select>
							<el-time-select class="limitedTimePicker" placeholder="结束" v-model="item[1]"
								:picker-options="{
							  start: '00:00',
							  step: '00:10',
							  end: '24:00',
							  minTime:  i > 0 && business[i-1][1] ? business[i-1][1].split(':')[0]+':'+(business[i-1][1].split(':')[1]-1) : '',
							}"></el-time-select>
						</el-col>
					</el-form-item>
				</el-col>

				<el-col :span="12">

					<el-form-item label="停车场开放时间：" :label-width="formLabelWidth">
						<el-col v-for="(item,i) in parkingLotOpen" :key="i">
							<el-time-select class="limitedTimePicker" placeholder="开始" v-model="item[0]"
								:picker-options="{
					  start: '00:00',
					  step: '00:10',
					  end: '24:00',
					  minTime:  i > 0 && parkingLotOpen[i-1][1] ? parkingLotOpen[i-1][1].split(':')[0]+':'+(parkingLotOpen[i-1][1].split(':')[1]-1) : '',
					}"></el-time-select>
							<el-time-select class="limitedTimePicker" placeholder="结束" v-model="item[1]"
								:picker-options="{
							  start: '00:00',
							  step: '00:10',
							  end: '24:00',
							  minTime:  i > 0 && parkingLotOpen[i-1][1] ? parkingLotOpen[i-1][1].split(':')[0]+':'+(parkingLotOpen[i-1][1].split(':')[1]-1) : '',
							}"></el-time-select>
						</el-col>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="营业类型：" :label-width="formLabelWidth" prop="businessType">
						<el-select placeholder="营业类型" v-model="editForm.businessType">
							<el-option v-for="item in businessTypeDataNew" :key="item.value" v-bind:label="item.message"
								v-bind:value="item.value"></el-option>
						</el-select>
					</el-form-item>
				</el-col>

				<el-col :span="12">
					<el-form-item label="是否收取停车费：" :label-width="formLabelWidth" prop="isParkingFee">
						<el-select placeholder="是否收取停车费" v-model="editForm.isParkingFee">
							<el-option v-for="item in isParkingFeeList" :key="item.value" v-bind:label="item.message"
								v-bind:value="item.value"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
        <el-col :span="12">
          <el-form-item label="停车位数量：" :label-width="formLabelWidth" prop="parkNum">
            <el-input autocomplete="off" v-model="editForm.parkNum"></el-input>
          </el-form-item>
        </el-col>

				<el-col :span="12">
					<el-form-item label="停车费说明：" :label-width="formLabelWidth" prop="parkingNotice">
						<el-input autocomplete="off" v-model="editForm.parkingNotice" placeholder="以场地实际收费为准">
						</el-input>
					</el-form-item>
				</el-col>


				<el-col :span="12">
					<el-form-item label="快慢充：" :label-width="formLabelWidth" prop="fastOrSlow">
						<el-select placeholder="供移动端展示" v-model="editForm.fastOrSlow">
							<el-option v-for="item in fastOrSlowData" :key="item.value" v-bind:label="item.message+'站'"
								v-bind:value="item.value"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="12">
			        <el-form-item label="交付时间" :label-width="formLabelWidth" prop="deliveryTime">
			          <el-date-picker v-model="editForm.deliveryTime" type="date" value-format="yyyy-MM-dd" placeholder="选择日期时间"></el-date-picker>
			        </el-form-item>
			      </el-col>
			      <el-col :span="12">
			        <el-form-item label="保修时间" :label-width="formLabelWidth" prop="warrantyPeriod">
			          <el-date-picker v-model="editForm.warrantyPeriod" type="date" value-format="yyyy-MM-dd" placeholder="选择日期时间"></el-date-picker>
			        </el-form-item>
			      </el-col>
			      <el-col :span="12">
			        <el-form-item label="延保时间" :label-width="formLabelWidth" prop="extendWarranty">
			          <el-date-picker v-model="editForm.extendWarranty" type="date" value-format="yyyy-MM-dd" placeholder="选择日期时间"></el-date-picker>
			        </el-form-item>
			      </el-col>
			      <el-col :span="12">
			        <el-form-item label="销售人" :label-width="formLabelWidth" prop="salesman">
			          <el-input autocomplete="off" v-model="editForm.salesman" placeholder="请填写销售人名称"></el-input>
			        </el-form-item>
			      </el-col>
			      <el-col :span="12">
			        <el-form-item label="销售人联系方式" :label-width="formLabelWidth" prop="salesmanPhone">
			          <el-input autocomplete="off" v-model="editForm.salesmanPhone" placeholder="请填写销售人联系方式"></el-input>
			        </el-form-item>
			      </el-col>

				<el-col :span="12">
			        <el-form-item label="是否允许开票：" :label-width="formLabelWidth" prop="isInvoice">
			          <el-select placeholder="请选择" v-model="editForm.isInvoice">
			            <el-option v-for="item in YesNoEnumData" :key="item.value"
			                       v-bind:label="item.message" v-bind:value="item.value"></el-option>
			          </el-select>
			        </el-form-item>
			      </el-col>

        <el-col :span="12">
          <el-form-item label="是否接收平台券：" :label-width="formLabelWidth" prop="isCoupons">
            <el-select placeholder="请选择" v-model="editForm.isCoupons">
              <el-option v-for="item in isCouponsData" :key="item.value" v-bind:label="item.message"
                         v-bind:value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>


				<el-col :span="12">
					<el-form-item label="是否互联互通：" :label-width="formLabelWidth" prop="isCec">
						<el-select placeholder="请选择" v-model="editForm.isCec">
							<el-option v-for="item in isCecData" :key="item.value" v-bind:label="item.message"
								v-bind:value="item.value"></el-option>
						</el-select>
					</el-form-item>
				</el-col>

				<!--     互联互通的     -->
				<div v-if="editForm.isCec == 'Y'">
					<el-col :span="12">
						<el-form-item label="设备所属方id：" :label-width="formLabelWidth" prop="equipmentOwnerID">
							<el-input autocomplete="off" placeholder="公司组织机构代码" v-model="editForm.equipmentOwnerID">
							</el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="充电站国家代码：" :label-width="formLabelWidth" prop="countryCode">
							<el-input autocomplete="off" placeholder="例如CN" v-model="editForm.countryCode"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="地区代码：" :label-width="formLabelWidth" prop="areaCode">
							<el-input autocomplete="off" placeholder="省市区编码GB/T 2260-2007" v-model="editForm.areaCode">
							</el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="站点电话：" :label-width="formLabelWidth" prop="stationTel">
							<el-input autocomplete="off" v-model="editForm.stationTel"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="服务电话：" :label-width="formLabelWidth" prop="serviceTel">
							<el-input autocomplete="off" v-model="editForm.serviceTel"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="站点引导：" :label-width="formLabelWidth" prop="siteGuide">
							<el-input autocomplete="off" v-model="editForm.siteGuide"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="使用车型描述：" :label-width="formLabelWidth" prop="matchCars">
							<el-input autocomplete="off" v-model="editForm.matchCars"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="车位楼层及数量描述：" :label-width="formLabelWidth" prop="parkInfo">
							<el-input autocomplete="off" v-model="editForm.parkInfo"></el-input>
						</el-form-item>
					</el-col>
					<!--            <el-col :span="12">-->
					<!--              <el-form-item label="支付方式：" :label-width="formLabelWidth" prop="payment">-->
					<!--                <el-input autocomplete="off" v-model="editForm.payment"></el-input>-->
					<!--              </el-form-item>-->
					<!--            </el-col>-->
<!--					<el-col :span="12">
						<el-form-item label="是否支持预约：" :label-width="formLabelWidth" prop="supportOrder">
							<el-select placeholder="请选择" v-model="editForm.supportOrder">
								<el-option v-for="item in YesNoEnumData" :key="item.value" v-bind:label="item.message"
									v-bind:value="item.value"></el-option>
							</el-select>
						</el-form-item>
					</el-col>-->
				</div>
				<div v-else></div>
				<!--隐藏id-->
				<el-col :span="12">
					<el-form-item hidden label="id" :label-width="formLabelWidth" prop="id">
						<el-input v-model="editForm.id" autocomplete="off"></el-input>
					</el-form-item>
				</el-col>
			</el-form>
			<!--footer -->
			<div slot="footer" class="dialog-footer">
				<el-button size="mini" plain @click="clearEditForm">取 消</el-button>
				<el-button size="mini" plain type="primary" @click.native="editSubmit" :loading="editSubmitLoading">提交
				</el-button>
			</div>
		</el-dialog>
		<!--   地图组件   -->
		<el-dialog width="40%" :visible.sync="dialogInnerVisible" :modal-append-to-body='false'>
			<!--快速搜索 form-->
			<el-form :model="innerForm" ref="innerForm" :inline="true" size="mini">
				<el-tabs v-model="innerFormName">
					<!--经纬坐标-->
					<el-tab-pane label="经纬坐标" name="coordinate">
						<el-row class="el_row_input row_input">
							<el-col :span="10" class="el_col_input">
								<el-form-item label="经度：">
									<el-input autocomplete="off" v-model="centerTemp.lng"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="10" :offset="2" class="el_col_input">
								<el-form-item label="纬度：">
									<el-input autocomplete="off" v-model="centerTemp.lat"></el-input>
								</el-form-item>
							</el-col>
							<!--                <el-col :span="2">-->
							<!--                  <el-form-item>-->
							<!--                    <el-button size="mini" class="el_search">搜索</el-button>-->
							<!--                  </el-form-item>-->
							<!--                </el-col>-->
						</el-row>
						<!--百度地图组件-->
						<div class="BaiduMap">
              <div id="mapcontainer"></div>
						</div>
						<!--内部对话框底部当前位置-->
						<el-row class="el_row_input rows_input">
							<el-col :span="24" class="el_col_input">
								<el-form-item>
									<label style="color: sienna;font-weight: bold" v-text="addressTemp"></label>
								</el-form-item>
							</el-col>
						</el-row>
					</el-tab-pane>
				</el-tabs>
			</el-form>

      <!-- 搜索地区 -->
      <el-input placeholder="请输入地名关键字" type="text" size="small" class="qqMapInput" v-model="qqMapInputs" id="keyword"
                @input="qqMapInputChange"></el-input>

      <ul id="suggestionList" v-if="qqMapList.length !== 0">
        <li v-for="(item, index) in qqMapList" :key="index" @click="qqMapListItem(index)">
          {{ item.address }}
        </li>
      </ul>



			<div slot="footer" class="dialog-footer">
				<el-button size="mini" plain @click="cancellation =false ">取 消</el-button>
				<el-button size="mini" plain type="primary" @click="confirmAddress">提交</el-button>
			</div>
		</el-dialog>
	</div>
</template>



<script>
	import {
		validateInput,
		validatePhoneThree,
		validateTime,
		checkSomePhone
	} from '../../../../common/validator'
  import operatorApi from '@/module/memberCenter/api/operator.js'
	export default {
		name: "add",
		data() {
			return {
				parkLockList:[
					{
						value: 'Y',
						message: '是'
					},
					{
						value: 'N',
						message: '否'
					}
				],
        isParkingFeeList: [
          {
            value: "Y",
            message: "收费停车",
          },
          {
            value: "N",
            message: "免费停车",
          }
        ],
        businessTypeDataNew:[
          {
            value: "OWN",
            message: "自营",
          },
          {
            value: "OTHER",
            message: "独立运营",
          },
        ],

				editFormRules: {
					stationName: [{
						required: true,
						message: '请输入站名称',
						trigger: 'blur'
					}, {
						validator: function(rule, value, callback) {
							validateInput(rule, value, callback, 0, 15, true, true, false, false, false, false,
								false)
						},
						trigger: 'blur'
					}],
					stationType: [{
						required: true,
						message: '请选择站类型',
						trigger: 'blur'
					}],
					stationStatus: [{
						required: true,
						message: '请选择站状态',
						trigger: 'blur'
					}],
					canUse: [{
						required: true,
						message: '请选择是否启用',
						trigger: 'blur'
					}],
				/*	longitude: [{
						required: true,
						message: '请上传充电站地址',
						trigger: 'blur'
					}],
					latitude: [{
						required: true,
						message: '请上传充电站地址',
						trigger: 'blur'
					}],
					areaCode: [{
						required: true,
						message: '请输入地区编码',
						trigger: 'blur'
					}],*/
          addressType: [
            {
              required: true,
              message: "请选择地区类型",
              trigger: "blur",
            },
          ],
					address: [{
						required: true,
						message: '请选择地址',
						trigger: 'blur'
					}, {
						validator: function(rule, value, callback) {
							validateInput(rule, value, callback, 0, 127, true, false, false, false, false,
								false, false)
						},
						trigger: 'blur'
					}],
					siteArea: [{
						validator: function(rule, value, callback) {
							validateInput(rule, value, callback, 0, 15, true, false, false, false, false,
								false, true)
						},
						trigger: 'blur'
					}],
					// addressType: [{required: true, message: '请选择地区类型', trigger: 'blur'}],
					dutyPerson: [{
						required: true,
						message: '请输入负责人',
						trigger: 'blur'
					}, {
						validator: function(rule, value, callback) {
							validateInput(rule, value, callback, 0, 10, true, true, false, false, true, false,
								false)
						},
						trigger: 'blur'
					}],
					dutyPersonPhone: [{
						required: true,
          /*  type:'number',
            transform(value) {
              if(value){
                return Number(value);
              }
            },*/
						message: '请输入服务电话',
						trigger: 'blur'
					}],
					managementPrice: [{
						validator: function(rule, value, callback) {
							validateInput(rule, value, callback, 0, 15, true, false, false, false, false,
								false, true)
						},
						trigger: 'blur'
					}],
					businessHours: [{
						validator: validateTime,
						trigger: 'blur'
					}],
          isParkingFee: [{required: true, message: '请选择是否收取停车费', trigger: 'blur'}],
					parkNum: [{
						validator: function(rule, value, callback) {
							validateInput(rule, value, callback, 0, 10, true, true, true, true, false, false,
								false)
						},
						trigger: 'blur'
					}],
					parkingLotOpenHours: [{
						validator: validateTime,
						trigger: 'blur'
					}],
					parkingLotFee: [{
						validator: function(rule, value, callback) {
							validateInput(rule, value, callback, 0, 10, true, false, false, false, false,
								false, true)
						},
						trigger: 'blur'
					}, {
            required: true,
            message: "请输入停车费用",
            trigger: "blur",
          },],
					// feesTakeUpPile: [{required: true, message: '请输入是否启用占桩计费', trigger: 'blur'}],
					parkingNotice: [{
						validator: function(rule, value, callback) {
							validateInput(rule, value, callback, 0, 50, true, false, false, false, false,
								false, false)
						},
						trigger: 'blur'
					}, {
            required: true,
            message: "请输入停车费说明",
            trigger: "blur",
          },],
					takeUpTime: [{
						validator: function(rule, value, callback) {
							validateInput(rule, value, callback, 0, 10, true, true, true, true, false, false,
								false)
						},
						trigger: 'blur'
					}],
					takeUpPrice: [{
						validator: function(rule, value, callback) {
							validateInput(rule, value, callback, 0, 10, true, false, false, false, false,
								false, true)
						},
						trigger: 'blur'
					}],
					operatorId: [{
						required: true,
						message: '请选择运营商',
						trigger: 'blur'
					}],
					serviceBillingRulesIdTemp: [{
						validator: (rule, value, callback) => {
							if (!this.editForm.id && !value) {
								callback(new Error('请选择费率'))
							} else {
								callback()
							}
						},
						trigger: 'change'
					}],
					// managementPrice: [{required: true, message: '请输入运营管理费', trigger: 'blur'}, {validator: isDecimalThanZero, trigger: 'blur'}],
					fastOrSlow: [{
						required: true,
						message: '请选择快慢充',
						trigger: 'blur'
					}],
			/*		commissionChargeFlag: [{
						required: true,
						message: '请选择是否佣金开启充电',
						trigger: 'blur'
					}],*/
					isInvoice: [{required: true, message: '请选择是否允许开票', trigger: 'blur'}],
         // 				isNaming: [{required: true, message: '请选择是否允许冠名', trigger: 'blur'}],
					businessType: [{
						required: true,
						message: '请选择营业类型',
						trigger: 'blur'
					}],
					isCec: [{
						required: true,
						message: '请选择是否互联互通',
						trigger: 'blur'
					}],
				/*	isProfit: [{
						required: true,
						message: '请选择是否参与分润',
						trigger: 'blur'
					}],*/
				},
				formLabelWidth: '150px',
				// 百度地图初始化数据
				dialogInnerVisible: false, // 内部对话框
				innerForm: {},
				innerFormName: 'coordinate',
				styleJson: [ // 百度地图自定义
					{
						featureType: "water",
						elementType: "all",
						stylers: {
							color: "#ffffff"
						}
					}
				],
				baidumapSwitch: false,
				zoom: 16,
				location: '上海市',
				keyword: '',
				centerTemp: {
					lng: 121.384555,
					lat: 31.069087
				},
				// 设置center属性值
				provinceTemp: '',
				cityTemp: '',
				districtTemp: '',
				addressTemp: '',
				// 营业时间
				business: [
					["00:00", "24:00"]
				],
				// 停车场开放时间
				parkingLotOpen: [
					["00:00", "24:00"]
				],
        // 腾讯地图
        mapLatLng: null, // 定义地图中心点坐标
        qqMap: null, // 构造函数创建地图
        marker: null, // 获取地图的中心点
        qqMapInputs: "", // 搜索地区
        qqMapList: [], // 搜索地区信息
        search: null, // 新建一个地点搜索类
        suggest: null, // 新建一个关键字输入提示类
			}
		},
		methods: {
			operatorDisable(item) {
				// 判断是否为潜在运营商
				const flag = (item.checked && (item.checked === 'unchecked' || item.checked === 'unapproved')) ? true :
					false
				return flag
			},
			//对数据进行授权过滤
			setTreeDisable(val) {
        this.editForm.operatorId=sessionStorage.getItem('operatorId');
				//对 treeList 进行递归操作，禁止选中unchecked和unapproved
				val && val.forEach(item => {
					if ((item.checked && (item.checked === 'unchecked' || item.checked === 'unapproved'))) {
						item.disabled = true; // 如果类型为unchecked或者unapproved，就增加禁用选项
					}
					if (item.children) {
						this.setTreeDisable(item.children);
					}
				});
				return val;
			},
			handleChangeOperator(value) {
				let operatorId = value && value.length > 0 ? value[value.length - 1] : ''
				this.editForm.operatorId = operatorId
				this.$refs.cascader.dropDownVisible = false
			},
      clearEditForm() {
        let _this = this;
        if (this.editForm.id == null || this.editForm == "") {
          this.$confirm("是否要取消当前操作？")
            .then((_) => {
              _this.$refs.editForm.clearValidate();
              _this.$emit("closeAddForm");
            })
            .catch((_) => { });
        } else {
          _this.$refs.editForm.clearValidate();
          _this.$emit("closeAddForm");
        }
      },

      // 点击搜索地址定位到地图位置
      qqMapListItem(e) {
        this.qqMapInputs = this.qqMapList[e].address;
        this.qqMapList = [];
        var geocoder = new TMap.service.Geocoder();
        this.$nextTick(() => {
          geocoder.getLocation({ address: this.qqMapInputs }).then((result) => {
            console.log(result, "29192281381293");
            this.centerTemp.lng = result.result.location.lng;
            this.centerTemp.lat = result.result.location.lat;
            // 销毁地图
            this.qqMap.destroy();

            let lngs = this.centerTemp.lng;
            let lats = this.centerTemp.lat;
            // 定义地图中心点坐标
            var mapLatLng = new window.TMap.LatLng(lats, lngs);

            // 定义map变量，调用 TMap.Map() 构造函数创建地图
            this.qqMap = new window.TMap.Map(
              document.getElementById("mapcontainer"),
              {
                rotation: 20, //设置地图旋转角度
                pitch: 30, //设置俯仰角度（0~45）
                zoom: 16, //设置地图缩放级别
                center: mapLatLng, //设置地图中心点坐标
              }
            );

            this.qqMap.on("click", (e) => {
              const { lng, lat } = e.latLng; // 获取点击位置的经纬度
              // console.log(lng, lat); // 在控制台输出经纬度
              // console.log(e.poi, "292929");
              this.centerTemp.lng = lng;
              this.centerTemp.lat = lat;

              // 清除marker点
              if (this.marker) {
                this.marker.setMap(null);
                this.marker = null;
              }

              // 添加marker点
              this.marker = new window.TMap.MultiMarker({
                map: this.qqMap,
                //点标记数据数组
                geometries: [
                  {
                    id: "demo", //点标记唯一标识，后续如果有删除、修改位置等操作，都需要此id
                    styleId: "myStyle", //指定样式id
                    position: new window.TMap.LatLng(lat, lng), //点标记坐标位置
                    properties: {
                      //自定义属性
                      title: "marker",
                    },
                  },
                ],
              });
            });

            // 添加marker点
            this.marker = new window.TMap.MultiMarker({
              map: this.qqMap,
              //点标记数据数组
              geometries: [
                {
                  id: "demo", //点标记唯一标识，后续如果有删除、修改位置等操作，都需要此id
                  styleId: "myStyle", //指定样式id
                  position: new window.TMap.LatLng(
                    this.centerTemp.lat,
                    this.centerTemp.lng
                  ), //点标记坐标位置
                  properties: {
                    //自定义属性
                    title: "marker",
                  },
                },
              ],
            });
          });
        });
      },
      // 获取搜索位置
      qqMapInputChange() {
        if (this.qqMapInputs === "") {
          this.qqMapList = [];
          return;
        }
        this.$nextTick(() => {
          // 使用者在搜索框中输入文字时触发
          if (this.qqMapInputs !== "") {
            this.suggest
              .getSuggestions({
                keyword: this.qqMapInputs,
                location: this.qqMap.getCenter(),
              })
              .then((result) => {
                console.log(result, "0909090");
                this.qqMapList = result.data;
              })
              .catch((error) => {
                console.log(error);
              });
          }
        });
      },

      // 进入页面调用
      initmap() {
        this.search = new TMap.service.Search({ pageSize: 10 }); // 新建一个地点搜索类
        this.suggest = new TMap.service.Suggestion({
          // 新建一个关键字输入提示类
          pageSize: 10, // 返回结果每页条目数
          // region: "北京", // 限制城市范围
          // regionFix: true, // 搜索无结果时是否固定在当前城市
        });

        let lngs = this.centerTemp.lng;
        let lats = this.centerTemp.lat;
        // 定义地图中心点坐标
        this.mapLatLng = new window.TMap.LatLng(lats, lngs);

        // 定义map变量，调用 TMap.Map() 构造函数创建地图
        this.qqMap = new window.TMap.Map(
          document.getElementById("mapcontainer"),
          {
            rotation: 20, //设置地图旋转角度
            pitch: 30, //设置俯仰角度（0~45）
            zoom: 16, //设置地图缩放级别
            center: this.mapLatLng, //设置地图中心点坐标
          }
        );

        //获取地图的中心点
        this.marker = new window.TMap.MultiMarker({
          map: this.qqMap,
          //点标记数据数组
          geometries: [
            {
              id: "demo", //点标记唯一标识，后续如果有删除、修改位置等操作，都需要此id
              styleId: "myStyle", //指定样式id
              position: new window.TMap.LatLng(lats, lngs), //点标记坐标位置
              properties: {
                //自定义属性
                title: "marker",
              },
            },
          ],
        });

        this.qqMap.on("click", (e) => {
          const { lng, lat } = e.latLng; // 获取点击位置的经纬度
          // console.log(lng, lat); // 在控制台输出经纬度
          // console.log(e.poi, "292929");
          this.centerTemp.lng = lng;
          this.centerTemp.lat = lat;

          // 清除marker点
          if (this.marker) {
            this.marker.setMap(null);
            this.marker = null;
          }

          // 添加marker点
          this.marker = new window.TMap.MultiMarker({
            map: this.qqMap,
            //点标记数据数组
            geometries: [
              {
                id: "demo", //点标记唯一标识，后续如果有删除、修改位置等操作，都需要此id
                styleId: "myStyle", //指定样式id
                position: new window.TMap.LatLng(lat, lng), //点标记坐标位置
                properties: {
                  //自定义属性
                  title: "marker",
                },
              },
            ],
          });
        });
      },


			showInnerForm() {
				this.centerTemp.lng = this.editForm.longitude == null ? 121.384555 : this.editForm.longitude
				this.centerTemp.lat = this.editForm.latitude == null ? 31.069087 : this.editForm.latitude
				this.provinceTemp = this.editForm.province
				this.cityTemp = this.editForm.city
				this.districtTemp = this.editForm.area
				this.addressTemp = this.editForm.address
				this.dialogInnerVisible = true
        this.$nextTick(() => {
          this.initmap();
        });
			},
			// 点击获取到当前经纬度
/*			getClickInfo(e) {
				const myGeo = new window.BMap.Geocoder()
				myGeo.getLocation(e.point, data => {
					if (data) {
						this.centerTemp = {
							lng: e.point.lng,
							lat: e.point.lat
						}
						this.provinceTemp = data.addressComponents.province
						this.cityTemp = data.addressComponents.city
						this.districtTemp = data.addressComponents.district
						this.addressTemp = data.address
					}
				})
			},*/

      cancellation() {
        this.dialogInnerVisible = false;
        // 销毁地图
        this.qqMap.destroy();
        this.qqMapList = [];
        this.qqMapInputs = "";
      },


			confirmAddress() {
				//this.editForm.longitude = this.centerTemp.lng
				//this.editForm.latitude = this.centerTemp.lat
				this.editForm.province = this.provinceTemp
				this.editForm.city = this.cityTemp
				this.editForm.area = this.districtTemp
				// this.editForm.address = this.addressTemp
				/*Vue实例创建时，editForm.属性名并未声明，因此Vue就无法对属性执行 getter/setter 转化过程，
				导致editForm属性不是响应式的，因此无法触发视图更新。
				解决的方式有两种，第一种就是显示的声明editForm这个对象的属性
				* 其次也可以使用使用Vue的全局API: $set()赋值*/
				this.$set(this.editForm, 'address', this.addressTemp)
				document.getElementById("address").focus()
				document.getElementById("address").blur()
				this.$set(this.editForm, 'longitude', this.centerTemp.lng);
				this.$set(this.editForm, 'latitude', this.centerTemp.lat);
				this.$refs.editForm.clearValidate("longitude");
				this.$refs.editForm.clearValidate("latitude");
				this.dialogInnerVisible = false

        // 确定经纬度转换具体地址
        let lng = this.centerTemp.lng;
        let lat = this.centerTemp.lat;

        // console.log(lng, lat);
        var geocoder = new window.TMap.service.Geocoder();
        var map = new window.TMap.Map("mapcontainer", {
          zoom: 14,
          center: new window.TMap.LatLng(lat, lng),
        });
        var markers = new window.TMap.MultiMarker({
          map: map,
          geometries: [],
        });
        markers.setGeometries([]);
        var location = new window.TMap.LatLng(lat, lng);
        map.setCenter(location);
        markers.updateGeometries([
          {
            id: "main", // 点标注数据数组
            position: location,
          },
        ]);
        geocoder
          .getAddress({ location: location }) // 将给定的坐标位置转换为地址
          .then((result) => {
            // console.log("kkkk"+JSON.stringify(result));
            // console.log(result.result.address_component.city);
            // 显示搜索到的地址
            this.editForm.province = result.result.address_component.province;
            this.editForm.city = result.result.address_component.city;
            this.editForm.area = result.result.address_component.district;
            // this.editForm.address = result.result.address;
            this.editForm.address = result.result.formatted_addresses.recommend;
            this.editForm.areaCode = result.result.ad_info.adcode;
          });

        // 销毁地图
        this.qqMap.destroy();
        this.qqMapList = [];
        this.qqMapInputs = "";
			},
			// 编辑登记提交
			editSubmit() {
				this.editForm.parkLock = this.editForm.parkLockCode;
				this.editForm.businessHours = this.business[0][0] + '-' + this.business[0][1];
				this.editForm.parkingLotOpenHours = this.parkingLotOpen[0][0] + '-' + this.parkingLotOpen[0][1];
				let Bool = true
				//console.log(this.editForm.businessHours)
				this.editForm.businessHours.split('-').forEach(item => {
					if (item == 'null') {
						Bool = false
						this.$message.error('请输入营业时间段，格式00:00-24:00');
						return
					}
				})
				this.editForm.parkingLotOpenHours.split('-').forEach(item => {
					if (item == 'null') {
						Bool = false
						this.$message.error('请输入停车场开发时间段，格式00:00-24:00');
						return
					}
				})
				if(Bool){

					console.log(this.$refs.editForm)
					this.$emit('editSubmit', this.$refs.editForm)
				}
			},
		},
		props: {
      addFormVisible: {
				type: Boolean,
				required: true
			},
			editForm: {},
			editSubmitLoading: false,
			operatorForSelect: '',
			stationTypeData: '',
			stationStatusData: '',
			addressTypeData: '',
			businessTypeData: '',
			YesNoEnumData: '',
			feesTakeUpPileData: '',
			fastOrSlowData: '',
			isCecData: '',
			isProfitData: '',
			isCouponsData: "",
			serviceBillingRulesSelect: {
				type: Array,
				default: () => []
			}
		},
		watch: {
			editForm: {
				handler(newValue, oldValue) {
					console.log(newValue)
					if (newValue.businessHours&&newValue.businessHours!='-') {
						this.business = [newValue.businessHours.split('-')]
					} else {
						this.business = [
							["00:00", "24:00"]
						]
					}
				},
				deep: true
			}
		},
	}
</script>

<style lang="less" scoped>
#suggestionList {
  position: absolute;
  background: #ffffff;
  border: 1px solid #f6f6f6;
  border-radius: 5px;
  padding: 0;
  top: 172px;
  left: 20px;
  z-index: 9999;
  list-style-type: none;
  margin: 0;
}

#suggestionList li {
  height: 40px;
  line-height: 40px;
  padding: 0 10px;
  cursor: pointer;
  text-align: left;
  border-bottom: 1px solid #e5e5e5;
  font-size: 12px;
}

#suggestionList li:last-of-type {
  border-bottom: none;
}

#suggestionList li:hover {
  background-color: #ebebeb;
}

.mapEldialog {
  position: relative;
}

.qqMapInput {
  z-index: 9999;
  position: absolute;
  top: 140px;
  left: 20px;
  width: 185px;
}

.qqMapButton {
  z-index: 9999;
  position: absolute;
  top: 70px;
  left: 178px;
}

#mapcontainer {
  height: 400px;
}

.BaiduMap {
  height: 400px;

  // div {
  //   height: 400px;
  // }
}

.limitedTimePicker {
  width: 96px !important;
  margin-bottom: 2px;
}
</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/siteManager/add.vue